import BaseModelAPI from '../BaseModelAPI';

export default class UserSignature extends BaseModelAPI {
	static entity = 'usersignature';
	static entityName = 'usersignature';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.userId = '';
			this.user = {};
			this.name = '';
			this.signatureId = '';
			this.signature = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}